import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import FontIcon from 'components/FontIcon';
import classes from './SiteNavBMobileLevelD.module.scss';

const SiteNavBMobileLevelD = (props) => {
  const {
    isVisible,
    heading,
    href,
    target,
    items = [],
  } = props;

  const renderLinks = (item, itemIndex) => {
    const {
      isVisible: treeItemIsVisible,
      heading: treeItemHeading,
      href: treeItemHref,
      target: treeItemTarget,
      items: treeItemChildren,
    } = item;

    return (
      treeItemIsVisible &&
        <div className={classes.treeItemContainer} key={`link-${itemIndex}`}>
          {href &&
            <Link
              href={treeItemHref}
              target={treeItemTarget}
              dangerouslySetInnerHTML={{ __html: treeItemHeading }}
            />}
          <div className={classes.childItemsContainer}>
            {treeItemChildren.map(({
              isVisible: childIsVisible,
              heading: childHeading,
              href: childHref,
              target: childTarget,
            }, childIndex) => (
              childIsVisible &&
                <div
                  className={classes.childLinkContainer}
                  key={`childLink-${childIndex}`}
                >
                  <Link
                    href={childHref}
                    target={childTarget}
                    dangerouslySetInnerHTML={{ __html: childHeading }}
                  />
                </div>
            ))}
          </div>
        </div>
    );
  };

  return (
    isVisible ? (
      <div className={classes.container}>
        <div className={classes.menuHeading}>
          {href &&
            <Link
              href={href}
              target={target}
              key={href}
              className={classes.menuHeadingLink}
            >
              <div
                className={classes.menuHeadingTitle}
                dangerouslySetInnerHTML={{ __html: heading }}
              />
              <FontIcon icon='far fa-chevron-right' className={classes.menuIcon} />
            </Link>}
        </div>
        {items.map((item, itemIndex) => renderLinks(item, itemIndex))}
      </div>) : null
  );
};

const TItem = PropTypes.shape({
  isVisible: PropTypes.bool,
  heading: PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.string,
  items: PropTypes.array,
});

SiteNavBMobileLevelD.propTypes = {
  isVisible: PropTypes.bool,
  href: PropTypes.string,
  heading: PropTypes.string,
  target: PropTypes.string,
  items: PropTypes.arrayOf(TItem),
};

export default SiteNavBMobileLevelD;
